import styles from "./spinner.module.css";
import { SpinnerLegacy } from "./SpinnerLegacy";

export function FullPageSpinner() {
  return (
    <div className={styles.container}>
      <SpinnerLegacy />
    </div>
  );
}
